import axios from "axios";

export const host = process.env.REACT_APP_API_URL

const axiosInstance = axios.create({
  baseURL: host,
  timeout: 1000000,
  headers: { "Content-Type": "application/json" },
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      // Handle unauthorized access
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
